export default __webpack_public_path__ + "static/media/head.60a441c6.jpg";